import Bookings from "./pages/Bookings/Bookings";
import Payment from "./pages/Payments/Payments";
import PaymentScheme from "./pages/payamentScheme/PaymentScheme";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import Dashboard from "./pages/Dashboard/Dashboard";
import Organization from "./pages/Organization/Organization";
import PlanManagement from "./pages/PlanManagement/PlanManagement";
import Holiday from "./pages/Holiday/Holiday";
import Roles from "./pages/Roles/Roles";
import Specialities from "./pages/Specialities/Specialities";
import CreateStaff from "./pages/Staff/CreateStaff";
import Staff from "./pages/Staff/Staff";
import Trust from "./pages/Trust/Trust";
import Profile from "./pages/Profile/Profile";
import OrgProfile from "./pages/Profile/OrgProfile";
import Signee from "./pages/Signee/Signee";
import ComplianceDocument from "./pages/compliance-document/ComplianceDocument"
import Notification from "./pages/Notification/Notification";
import StaffUserProfile from "./pages/StaffUser/StaffUserProfile/StaffUserProfile";
import Report from "./pages/Report/Reports";
import Umbrella from "./pages/UmbrellaCompany/Umbrella";
import Category from "./pages/Category/Category";
import Categories from "./pages/Categories/Categories";
import SubCategory from "./pages/SubCategory/SubCategory";
import SystemLogs from "./pages/SystemLogs/SystemLogs";
import NotificationPreference from "./pages/NotificationPreference/NotificationPreference";
import UserNotificationPreference from "./pages/UserNotificationPreference/UserNotificationPreference";
import InvoiceStudio from "./pages/InvoiceStudio/InvoiceStudio";
import Timesheet from "./pages/Timesheet/Timesheet";
import Invoice from "./pages/Invoice/Invoice";
import DashboardIcon from '@material-ui/icons/Dashboard';
import OrganizationDashboard from "./pages/Dashboard/OrganizationDashboard";
import { Banknote, Building2, CalendarCheck, CirclePoundSterling, ClipboardClock, FileCheck, FileCog, FilePen, FileText, List, ReceiptText, Settings, ShieldCheck, Split, TentTree, TextSelect, User, UserRoundCheck, Users, UsersRound } from "lucide-react";
const loginUserInfo = JSON.parse(window.localStorage.getItem("loginUserInfo"));

const Routes = [
  {
    name: "Dashboard",
    path: "dashboard",
    component: Dashboard,
    icon: <DashboardIcon />,
    role: "superadmin",
  },
  {
    name: "Dashboard",
    path: "dashboard",
    component: OrganizationDashboard,
    icon: <DashboardIcon />,
    role: "staff",
  },
  {
    name: "Dashboard",
    path: "dashboard",
    component: OrganizationDashboard,
    icon: <DashboardIcon />,
    role: "organization",
  },
  {
    name: "Organizations",
    path: "organizations",
    component: Organization,
    icon: "business",
    role: "superadmin",
  },
  {
    name: "Plan Management",
    path: "plan",
    component: PlanManagement,
    icon: "account_tree",
    role: "superadmin",
  },
  {
    name: "Roles",
    path: "roles",
    component: Roles,
    icon: "manage_accounts",
    role: "superadmin",
  },
  {
    name: "change-password",
    path: "change-password",
    component:
      ChangePassword,
    icon: "assignment",
    role: "organization",
    sidebar: false,
  },

  {
    name: "Bookings",
    path: "bookings",
    component: Bookings,
    icon: <CalendarCheck />,
    role: "organization",
  },
  {
    name: "Bookings",
    path: "bookings",
    component: Bookings,
    icon: <CalendarCheck />,
    role: "staff",
  },
  {
    name: "Candidates",
    path: "candidate",
    component: Signee,
    icon: <User />,
    role: "organization",
  },
  {
    name: "Candidates",
    path: "candidate",
    component: Signee,
    icon: <User />,
    role: "staff",
  },

  {
    name: "Staff",
    path: "staff",
    component: Staff,
    icon: "people",
    role: "organization",
    children: [
      {
        name: "Create Staff",
        path: "create",
        component: CreateStaff,
      },
    ],
    sidebar: false
  },
  {
    name: "Staff",
    path: "staff",
    component: Staff,
    icon: "people",
    role: "staff",
    children: [
      {
        name: "Create Staff",
        path: "create",
        component: CreateStaff,
      },
    ],
    sidebar: false
  },

  {
    name: "Invoices",
    path: "Invoice",
    component: Invoice,
    icon: "assignment",
    role: "organization",
    sidebar: false,
  },
  {
    name: "Invoices",
    path: "Invoice",
    component: Invoice,
    icon: "assignment",
    role: "staff",
    sidebar: false,
  },

  {
    name: "Timesheets",
    path: "Timesheet",
    component: Timesheet,
    icon: "shield",
    role: "organization",
    sidebar: false
  },
  {
    name: "Timesheets",
    path: "Timesheet",
    component: Timesheet,
    icon: "shield",
    role: "staff",
    sidebar: false
  },

  {
    name: "Customers",
    path: "Customers",
    component: Trust,
    icon: <Users />,
    role: "organization",
  },
  {
    name: "Customers",
    path: "Customers",
    component: Trust,
    icon: <Users />,
    role: "staff",
  },
  {
    name: "Roles",
    path: "roles",
    component: Roles,
    icon: "manage_accounts",
    role: "organization",
    sidebar: false
  },
  {
    name: "Roles",
    path: "roles",
    component: Roles,
    icon: "manage_accounts",
    role: "staff",
    sidebar: false
  },

  {
    name: "Specialities",
    path: "specialities",
    component: Specialities,
    icon: "volunteer_activism",
    role: "organization",
    sidebar: false
  },
  {
    name: "Specialities",
    path: "specialities",
    component: Specialities,
    icon: "volunteer_activism",
    role: "staff",
    sidebar: false
  },

  {
    name: "Reports",
    path: "reports",
    component: Report,
    icon: <FileCheck />,
    role: "organization",
  },
  {
    name: "Reports",
    path: "reports",
    component: Report,
    icon: <FileCheck />,
    role: "staff",
    sidebar: ((loginUserInfo?.role === "STAFF" || loginUserInfo?.role === "ORGANIZATION")) ? true : false,
  },
  {
    name: "Compliance-document",
    path: "compliance-document",
    component: ComplianceDocument,
    icon: <FileText />,
    role: "staff",
    sidebar: ((loginUserInfo?.role === "STAFF" || loginUserInfo?.role === "ORGANIZATION")) ? true : false,
  },
  {
    name: "Compliance-document",
    path: "compliance-document",
    component: ComplianceDocument,
    icon: <FileText />,
    role: "organization",
  },
  {
    name: "Profile",
    path: "profile",
    component: Profile,
    // icon:"description",
    role: "superadmin",
    sidebar: false,
  },
  // {
  //   name: "Subscription",
  //   path: "payment",
  //   component: (loginUserInfo?.is_plan_expire === true) ? Payment : Payment,
  //   icon: "paid",
  //   role: "organization",
  //   sidebar: false,
  // },
  // {
  //   name: "Subscription",
  //   path: "payment",
  //   component: (loginUserInfo?.is_plan_expire === true) ? Payment : Payment,
  //   icon: "paid",
  //   role: "staff",
  //   sidebar: false,
  // },
  {
    name: "Organization Profile",
    path: "organization-profile",
    component: OrgProfile,
    // icon:"description",
    role: "organization",
    sidebar: false,
  },
  {
    name: "Staff Profile",
    path: "staff-profile",
    component: StaffUserProfile,
    icon: "people",
    role: "staff",
    sidebar: false,
  },
  {
    name: "Notification",
    path: "notification",
    component: Notification,
    // icon:"description",
    role: "organization",
    sidebar: false,
  },
  {
    name: "Umbrella Companies",
    path: "umbrella-company",
    component: Umbrella,
    icon: "umbrella",
    role: "organization",
    sidebar: false,
  },
  {
    name: "Umbrella Companies",
    path: "umbrella-company",
    component: Umbrella,
    icon: "umbrella",
    role: "staff",
    sidebar: false,
  },

  {
    name: "Invoice-Studio",
    path: "invoice-studio",
    component: InvoiceStudio,
    icon: "assignment",
    role: 'organization',
    sidebar: false,
  },
  {
    name: "Invoice-Studio",
    path: "invoice-studio",
    component: InvoiceStudio,
    icon: "assignment",
    role: 'staff',
    sidebar: false,
  },

  {
    name: "System-Logs",
    path: "systemlogs",
    component: (loginUserInfo?.role === "ORGANIZATION" || loginUserInfo?.is_smt === "Yes") ? SystemLogs : Bookings,
    icon: "assignment",
    role: "organization",
    sidebar: false,
  },
  {
    name: "System-Logs",
    path: "systemlogs",
    component: (loginUserInfo?.role === "ORGANIZATION" || loginUserInfo?.is_smt === "Yes") ? SystemLogs : Bookings,
    icon: "assignment",
    role: "staff",
    sidebar: false,
  },

  {
    name: "Notification-Preference",
    path: "notification-preference",
    component: (loginUserInfo?.role === "ORGANIZATION" || loginUserInfo?.is_smt === "Yes") ? NotificationPreference : Bookings,
    icon: "assignment",
    role: "organization",
    sidebar: false,
  },

  {
    name: "UserNotificationPreference",
    path: "user-notification-preference",
    component: (loginUserInfo?.role === "ORGANIZATION" || loginUserInfo?.is_smt === "Yes") ? UserNotificationPreference : Bookings,
    icon: "assignment",
    role: "organization",
    sidebar: false,
  },
  {
    name: "UserNotificationPreference",
    path: "user-notification-preference",
    component: (loginUserInfo?.role === "STAFF" || loginUserInfo?.is_smt === "Yes") ? UserNotificationPreference : Bookings,
    icon: "assignment",
    role: "staff",
    sidebar: false,
  },

  {
    name: "Holidays",
    path: "holiday",
    component: Holiday,
    icon: "holiday_village",
    role: "organization",
    sidebar: false,
  },
  {
    name: "Holidays",
    path: "holiday",
    component: Holiday,
    icon: "holiday_village",
    role: "staff",
    sidebar: false,
  },
  {
    name: "Compliance Category",
    path: "compliance-category",
    component: Category,
    icon: "category_icon",
    role: "organization",
    sidebar: false,
  },
  {
    name: "Compliance Category",
    path: "compliance-category",
    component: Category,
    icon: "category_icon",
    role: "staff",
    sidebar: false,
  },
  {
    name: "Categories",
    path: "manage-category",
    component: Categories,
    icon: "category_icon",
    role: 'organization',
    sidebar: false,
  },
  {
    name: "Categories",
    path: "manage-category",
    component: Categories,
    icon: "category_icon",
    role: 'staff',
    sidebar: false,
  },
  {
    name: "Sub Category",
    path: "subCategory",
    component: SubCategory,
    icon: "category_icon",
    role: "organization",
    sidebar: false
  },
  {
    name: "Sub Category",
    path: "subCategory",
    component: SubCategory,
    icon: "category_icon",
    role: "staff",
    sidebar: false,
  },
  {
    name: "Payment Schemes",
    path: "payment-scheme",
    component: PaymentScheme,
    icon: "paid",
    role: "organization",
    sidebar: ((loginUserInfo?.role !== "ORGANIZATION") && loginUserInfo?.is_consulatant === "Yes")
      ? true
      : false,
  },
  {
    name: "Payment Schemes",
    path: "payment-scheme",
    component: PaymentScheme,
    icon: "paid",
    role: "staff",
    sidebar: ((loginUserInfo?.role !== "ORGANIZATION") && loginUserInfo?.is_consulatant === "Yes")
      ? true
      : false,
  },

  //sub menu of Finance
  {
    name: "Finance",
    path: "Finance",
    component: Roles,
    icon: <Banknote />,
    role: 'staff,organization',
    sidebar: ((loginUserInfo?.role === "STAFF" && (loginUserInfo?.is_smt === "Yes")) || (loginUserInfo?.role === "ORGANIZATION"))
      ? true
      : false,
    child: [

      {
        name: "Invoice-Studio",
        path: "invoice-studio",
        component: InvoiceStudio,
        icon: <FileCog />,
        role: 'staff,organization',
        sidebar: ((loginUserInfo?.role === "STAFF" && ((loginUserInfo?.is_smt === "Yes"))) || (loginUserInfo?.role === "ORGANIZATION"))
          ? true
          : false,
      },

      {
        name: "Invoices",
        path: "Invoice",
        component: (loginUserInfo?.is_plan_expire === true && loginUserInfo?.role !== "SUPERADMIN") ? Payment : Invoice,
        icon: <ReceiptText />,
        role: "staff,organization",
        sidebar: ((loginUserInfo?.role === "STAFF" && ((loginUserInfo?.is_smt === "Yes"))) || (loginUserInfo?.role === "ORGANIZATION"))
          ? true
          : false,
      },
      {
        name: "Timesheets",
        path: "Timesheet",
        component: (loginUserInfo?.is_plan_expire === true && loginUserInfo?.role !== "SUPERADMIN") ? Payment : Timesheet,
        icon: <FilePen />,
        role: "staff,organization",
        sidebar: ((loginUserInfo?.role === "STAFF" && ((loginUserInfo?.is_smt === "Yes"))) || (loginUserInfo?.role === "ORGANIZATION"))
          ? true
          : false,
      },

    ],
  },

  //sub menu of setttig
  {
    name: "Settings",
    path: "settings",
    component: Roles,
    icon: <Settings />,
    role: 'staff,organization',
    sidebar: ((loginUserInfo?.role === "STAFF") || loginUserInfo?.role === "ORGANIZATION")
      ? true
      : false,
    child: [

      {
        name: "Roles",
        path: "roles",
        component: Roles,
        icon: <ShieldCheck />,
        role: 'staff,organization',
        sidebar: ((loginUserInfo?.role === "STAFF") || loginUserInfo?.role === "ORGANIZATION")
          ? true
          : false,
      },

      {
        name: "Staff",
        path: "staff",
        component: loginUserInfo?.is_plan_expire === true ? Payment : Staff,
        icon: <UsersRound />,
        role: "staff,organization",
        children: [
          {
            name: "Create Staff",
            path: "create",
            component:
              loginUserInfo?.is_plan_expire === true ? Payment : CreateStaff,
          },
        ],
        sidebar: (loginUserInfo?.role === "STAFF" || loginUserInfo?.role === "ORGANIZATION") ? true : false,
      },
      {
        name: "Specialities",
        path: "specialities",
        component: Specialities,
        icon: <Split />,
        role: 'staff,organization',
        sidebar: ((loginUserInfo?.role === "STAFF") || loginUserInfo?.role === "ORGANIZATION")
          ? true
          : false,
      },

      {
        name: "Holidays",
        path: "holiday",
        component: Holiday,
        icon: <TentTree />,
        role: 'staff,organization',
        sidebar: ((loginUserInfo?.role === "STAFF") || loginUserInfo?.role === "ORGANIZATION")
          ? true
          : false,
      },
      // {
      //   name: "Subscription",
      //   path: "payment",
      //   component:  Payment,
      //   icon: <UserRoundCheck />,
      //   role: 'staff,organization',
      //   sidebar: ((loginUserInfo?.role === "STAFF") || loginUserInfo?.role === "ORGANIZATION") ? true : false,
      // },
      {
        name: "Payment Schemes",
        path: "payment-scheme",
        component: PaymentScheme,
        icon: <CirclePoundSterling />,
        role: 'staff,organization',
        sidebar: (loginUserInfo?.is_consulatant === "Yes" || loginUserInfo?.role === "ORGANIZATION" || loginUserInfo?.role === "STAFF")
          ? true
          : false,
      },
      {
        name: "Compliance Category",
        path: "compliance-category",
        component: Category,
        icon: <TextSelect />,
        role: 'staff,organization',
        sidebar: ((loginUserInfo?.role === "STAFF" || loginUserInfo?.role === "ORGANIZATION")) ? true : false,
      },
      {
        name: "Categories",
        path: "manage-category",
        component: Categories,
        icon: <List />,
        role: 'staff,organization',
        sidebar: ((loginUserInfo?.role === "STAFF") || loginUserInfo?.role === "ORGANIZATION") ? true : false,
      },
      {
        name: "Umbrella Companies",
        path: "umbrella-company",
        component: Umbrella,
        icon: <Building2 />,
        role: 'staff,organization',
        sidebar: ((loginUserInfo?.role === "STAFF") || loginUserInfo?.role === "ORGANIZATION")
          ? true
          : false,
      },

      {
        name: "System-Logs",
        path: "systemlogs",
        component: (loginUserInfo?.role === "ORGANIZATION") ? SystemLogs : Bookings,
        icon: <ClipboardClock />,
        role: "organization",
        sidebar: (loginUserInfo?.role === "ORGANIZATION")
          ? true
          : false,
      },
      // {
      //   name: "System-Logs",
      //   path: "systemlogs",
      //   component: (loginUserInfo?.role === "STAFF" || loginUserInfo?.is_smt === "Yes") ? SystemLogs : Bookings,
      //   icon: "assignment",
      //   role: "staff",
      //   sidebar: (loginUserInfo?.role === "STAFF" || loginUserInfo?.is_smt === "Yes")
      //     ? true
      //     : false,
      // },


    ],
  },
];

export default Routes;
